// src/locales/certificate-vi.ts
export default {
    navigation: {
        certificates: 'Quản lý Giấy phép',
        certificateDashboard: 'Bảng điều khiển',
        licenseTypes: 'Loại Giấy phép',
        vietrroCertificate: 'Giấy phép Vietrro',
        wipoCertificate: 'Giấy phép WIPO',
        noipCertificate: 'Giấy phép Cục SHTT',
        associationLicenses: 'Giấy phép Hiệp hội',
        licenseProcess: 'Quy trình Cấp phép',
        licenseApplication: 'Yêu cầu cấp phép',
        licenseTracking: 'Theo dõi tiến độ',
        licenseApproval: 'Duyệt cấp phép',
        licenseHistory: 'Lịch sử cấp phép',
        integrations: 'Tích hợp',
        wipoIntegration: 'Tích hợp WIPO',
        vietrroIntegration: 'Tích hợp VIETRRO',
        noipIntegration: 'Tích hợp Cục SHTT',
        associationIntegration: 'Tích hợp Hiệp hội',
        certificateVerification: 'Xác thực giấy phép'
    },
    dashboard: {
        title: 'Bảng điều khiển Giấy phép',
        subtitle: 'Quản lý giấy phép và chứng nhận từ các tổ chức',
        stats: {
            totalApplications: 'Tổng đơn đăng ký',
            pendingApplications: 'Đơn chờ duyệt',
            activeCertificates: 'Giấy phép có hiệu lực',
            expiredCertificates: 'Đã hết hạn'
        },
        quickActions: {
            title: 'Thao tác nhanh',
            newApplication: 'Đăng ký giấy phép mới',
            newApplicationDesc: 'Tạo đơn đăng ký giấy phép',
            vietrroCert: 'Giấy phép Vietrro',
            vietrroCertDesc: 'Cấp giấy phép chính thức',
            tracking: 'Theo dõi tiến độ',
            trackingDesc: 'Xem trạng thái đơn đăng ký',
            verification: 'Xác thực giấy phép',
            verificationDesc: 'Kiểm tra tính hợp lệ'
        },
        recent: {
            applications: 'Đơn đăng ký gần đây',
            certificates: 'Giấy phép gần đây',
            viewAll: 'Xem tất cả',
            noApplications: 'Chưa có đơn đăng ký nào',
            noCertificates: 'Chưa có giấy phép nào'
        },
        distribution: {
            title: 'Phân bố theo loại giấy phép'
        }
    },
    application: {
        title: 'Đăng ký Giấy phép mới',
        subtitle: 'Tạo đơn đăng ký giấy phép cho tác phẩm của bạn',
        steps: {
            contentSelection: 'Chọn nội dung',
            certificateType: 'Loại giấy phép',
            applicationDetails: 'Chi tiết đơn',
            reviewSubmit: 'Xem lại & Gửi'
        },
        contentSelection: {
            title: 'Chọn tác phẩm cần đăng ký giấy phép',
            subtitle: 'Chọn một tác phẩm từ danh sách nội dung của bạn',
            noContent: 'Bạn chưa có tác phẩm nào được đăng ký.',
            registerNew: 'Đăng ký tác phẩm mới'
        },
        certificateType: {
            title: 'Chọn loại giấy phép',
            subtitle: 'Chọn loại giấy phép phù hợp với nhu cầu của bạn',
            types: {
                vietrro: {
                    name: 'Giấy phép Vietrro',
                    description: 'Giấy phép chính thức từ Vietrro, có hiệu lực tại Việt Nam'
                },
                wipo: {
                    name: 'Giấy phép WIPO Connect',
                    description: 'Giấy phép quốc tế từ Tổ chức Sở hữu trí tuệ thế giới'
                },
                noip: {
                    name: 'Giấy phép Cục SHTT',
                    description: 'Giấy phép từ Cục Sở hữu trí tuệ Việt Nam'
                },
                association: {
                    name: 'Giấy phép Hiệp hội',
                    description: 'Giấy phép từ các hiệp hội chuyên ngành'
                }
            },
            recommended: 'Khuyến nghị'
        },
        details: {
            title: 'Chi tiết đơn đăng ký',
            subtitle: 'Điền thông tin chi tiết về tác phẩm và quyền tác giả',
            workTitle: 'Tên tác phẩm',
            workType: 'Loại tác phẩm',
            description: 'Mô tả tác phẩm',
            firstPublicationDate: 'Ngày xuất bản lần đầu',
            creators: {
                title: 'Người sáng tạo',
                add: '+ Thêm người sáng tạo',
                name: 'Tên người sáng tạo',
                role: 'Vai trò',
                percentage: '% quyền',
                remove: 'Xóa',
                empty: 'Chưa có người sáng tạo nào được thêm'
            },
            required: 'Trường bắt buộc'
        },
        review: {
            title: 'Xem lại thông tin đăng ký',
            subtitle: 'Kiểm tra lại thông tin trước khi gửi đơn đăng ký',
            importantNotes: {
                title: 'Lưu ý quan trọng',
                processing: 'Đơn đăng ký sẽ được xử lý trong vòng 5-10 ngày làm việc',
                notification: 'Bạn sẽ nhận được thông báo qua email về kết quả xử lý',
                fee: 'Phí xử lý đơn sẽ được thông báo sau khi đơn được duyệt'
            }
        },
        buttons: {
            previous: 'Quay lại',
            continue: 'Tiếp tục',
            submit: 'Gửi đơn đăng ký'
        }
    },
    status: {
        draft: 'Nháp',
        submitted: 'Đã gửi',
        under_review: 'Đang duyệt',
        approved: 'Đã duyệt',
        rejected: 'Từ chối',
        active: 'Có hiệu lực',
        expired: 'Hết hạn',
        revoked: 'Đã thu hồi'
    },
    verification: {
        title: 'Xác thực Giấy phép',
        enterNumber: 'Nhập số giấy phép',
        verify: 'Xác thực',
        result: {
            valid: 'Giấy phép hợp lệ',
            invalid: 'Giấy phép không hợp lệ',
            expired: 'Giấy phép đã hết hạn',
            notFound: 'Không tìm thấy giấy phép'
        }
    },
    errors: {
        createApplication: 'Không thể tạo đơn đăng ký',
        submitApplication: 'Không thể gửi đơn đăng ký',
        loadApplications: 'Không thể tải danh sách đơn đăng ký',
        loadCertificates: 'Không thể tải danh sách giấy phép',
        loadStats: 'Không thể tải thống kê',
        verifyCertificate: 'Không thể xác thực giấy phép',
        registerWipo: 'Không thể đăng ký với WIPO',
        registerNoip: 'Không thể đăng ký với Cục SHTT',
        registerAssociation: 'Không thể đăng ký với hiệp hội'
    },
    certificateDetail: {
        id: "ID chứng nhận",
        code: "Mã chứng nhận",
        issuingAuthority: "Cơ quan cấp",
        status: {
            active: {
                title: 'Đang hoạt động',
                subTitle: 'Giấy chứng nhận này đang có hiệu lực'
            },
            pending: {
                title: 'Đang chờ duyệt',
                subTitle: 'Đơn đăng ký đang được xem xét'
            },
            expired: {
                title: 'Đã hết hạn',
                subTitle: 'Giấy chứng nhận đã hết hiệu lực'
            },
            revoked: {
                title: 'Đã thu hồi',
                subTitle: 'Giấy chứng nhận đã bị thu hồi'
            },
            default: {
                title: 'Không xác định',
                subTitle: ''
            },
        }
    }
};
